import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = "";
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [commodities] = useParameter<number[]>("@commodities");
  const [units, setUnits] = useParameter<number[]>("@units");
  const [calendar] = useParameter<number[]>("@calendar");
  const [xlsxCalendar] = useParameter<number[]>("@xlsx_calendar");
  const [commoditiesDisplay] = useParameter<number[]>("@commodities_display");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@commodities": commodities,
      "@commodities_display": commoditiesDisplay,
      "@calendar": calendar,
      "@units": units,
      "@xlsx_calendar": xlsxCalendar,
    });
  }, [title, subtitle, commodities, commoditiesDisplay, units, calendar, xlsxCalendar, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      if (parameters["@units"]) {
        setUnits((parameters["@units"].value as string[]).map(Number));
      }
    },
    [setUnits]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
